<template>
    <div class="yandex-map-wrapper">
        <yandex-map :settings="settings"
                    :coords="coords"
                    :zoom="zoom"
                    @map-was-initialized="initHandler"
                    v-model="card_coords"
        >
            <ymap-marker v-for="center in mapCenters"
                         :key="center.attributes.id"
                         :marker-id="center.attributes.id"
                         :coords="pickupLocationCoords(center)"
                         :icon="markerIcon"
                         @click="onClick"
            >
                <balloon_castom slot="balloon"
                                :address="center.attributes.address"
                                :time_work="center.attributes.description"
                />
            </ymap-marker>
        </yandex-map>
    </div>
</template>

<script>
    import { yandexMap, ymapMarker, loadYmap} from 'vue-yandex-maps'
    import Balloon_castom from "./balloon_custom";
    import {
        mapPickupLocations,
        pickupLocationCoords
    } from './contacts/pickup_locations';

    export default {
        components: {Balloon_castom, yandexMap, ymapMarker, },
        name: "yandex_map",
        props: {
            centers: Array,
            card_coords: Array
        },
        data: () => ({
            settings: {
                apiKey: '57459198-fab1-4a21-a731-c68f67b2ca5d',
                lang: 'ru_RU',
                coordorder: 'latlong',
                version: '2.1'
            },
            getCardCoords: Array,
            id: "",
            map: {},
            coords: [
                55.9711100,
                37.9208300,
            ],
            markerIcon: {
                layout: 'default#imageWithContent',
                imageHref: `https://img.icons8.com/ios-filled/100/2D9C37/marker.png`,
                imageSize: [28, 28],
                imageOffset: [0, 0]
            },
            zoom: 12
        }),
        methods: {
            pickupLocationCoords,
            onClick(e){
                this.map.setCenter(e.get('coords'), 17)
            },
            initHandler(obj){
                this.map = obj;
            }
        },
        computed: {
            mapCenters() {
                return mapPickupLocations(this.centers)
            }
        },
        watch: {
            card_coords: function(newCoord){
                if (this.map.setCenter && Array.isArray(newCoord) && newCoord.length === 2) {
                    this.map.setCenter(newCoord, 17)
                }
            }
        }
    }

</script>

<style scoped>
</style>
